module.exports = __webpack_public_path__ + "img/underbust.f2f3ff16.png";